module.exports = __webpack_public_path__ + "img/9788958761044.a8c6efa2.jpg";